<div class="auth-wrapper auth-v2">
  <a class="brand-logo" href="javascript:void(0);">
    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
    <h2 class="brand-text text-primary ml-1">{{ '' | enterpriseName }}</h2>
  </a>

  <div class="auth-inner row m-0">
    <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
      <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
        <img
          class="img-fluid"
          [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/login-v2-dark.svg'
              : 'assets/images/pages/login-v2.svg'
          "
          alt="Créer station"
        />
      </div>
    </div>

    <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
      <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
        <h2 class="card-title font-weight-bold mb-1">Créer votre entreprise</h2>
        <p class="card-text mb-2">Remplissez les informations ci-dessous pour créer votre entreprise.</p>

        <div class="form-group">
          <label class="form-label" for="nom_entreprise">Nom de l'entreprise</label>
          <input
            type="text"
            id="nom_entreprise"
            class="form-control"
            placeholder="Nom de l'entreprise"
            tabindex="1"
            [(ngModel)]="data.titre"
            [class.border-red]="dataError.titre"
          />
          <div class="alert-body red" *ngIf="dataError.titre">
            <p>{{ dataError.titre }}</p>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="nb_employer">Nombre d'employés</label>
          <select
            id="nb_employer"
            class="form-control"
            [(ngModel)]="data.nb_employer"
            tabindex="2"
            [class.border-red]="dataError.nb_employer"
          >
            <option value="" disabled selected>Choisissez</option>
            <option value="1-10">1 - 10</option>
            <option value="10-100">10 - 100</option>
            <option value="100+">100+</option>
          </select>
          <div class="alert-body red" *ngIf="dataError.nb_employer">
            <p>{{ dataError.nb_employer }}</p>
          </div>
        </div>

      

        <button
          [disabled]="loading"
          class="btn btn-primary btn-block"
          tabindex="4"
          (click)="create()"
        >
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          Créer
        </button>
      </div>
    </div>
  </div>
</div>
